import { styled } from '@linaria/react';
import { radius, semantic, size } from '../../theme/tokens';

export const GroupWrapper = styled.div<{ $error?: boolean }>`
  border: ${(p) => (p.$error ? size.stroke['stroke-thick'] : size.stroke['stroke-default'])} solid
    ${(p) => (p.$error ? semantic.border.danger : semantic.border.default)};
  border-radius: ${radius('input', 'radius-md')};
  box-sizing: border-box;
  overflow: visible;
`;

export const RowWrapper = styled.div<{ $multiChild: boolean }>`
  display: ${(p) => (p.$multiChild ? 'grid' : 'flex')};
  grid-template-columns: ${(p) => (p.$multiChild ? 'repeat(auto-fit, minmax(0, 1fr))' : 'none')};

  &:not(:last-child) {
    border-bottom: ${size.stroke['stroke-default']} solid ${semantic.border.default};
  }

  & > *:not(:last-child) {
    border-right: ${(p) =>
      p.$multiChild ? `${size.stroke['stroke-default']} solid ${semantic.border.default}` : 'none'};
  }
`;

export const RowCell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
`;
